import { Source } from 'api3';
import { Component, Input } from '@angular/core';
import { Tag } from 'primeng/tag';

@Component({
  selector: 'app-source-link-logo',
  standalone: true,
  imports: [Tag],
  templateUrl: './source-link-logo.component.html',
  host: { class: 'shrink-0' },
})
export class SourceLinkLogoComponent {
  @Input() provider: Source['provider'] | undefined = undefined;
}
